import { connect } from 'react-redux';
import ProgressTracker from './ProgressTracker';
import {
    progressTracker,
    progressTrackerLoading,
} from "../../../store/selectors/programs.selector";
import {
    updateProgressKPI,
    getProgressTracker,
} from "../../../store/actions/programs.actions";

const mapDispatchToProps = {
    updateProgressKPI,
    getProgressTracker,
};

const mapStateToProps = (state) => {
    const programProgress = progressTracker(state);
    const loading = progressTrackerLoading(state);
    return { programProgress, loading };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgressTracker);
